export default __webpack_public_path__ + "static/media/2b.c5192da4.png";